import { Component, Input, OnInit, Output } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';

import { FormlyService, SalesOrderService } from 'tms-lib';
import {
  PurchaseContractPropertyService,
  PurchaseOrderPropertyService,
  PurchaseOrderService,
  SalesOrderPropertyService,
} from '../../../services';
import { OrderProperty } from '../../../models';

@Component({
  selector: 'app-order-property-modal',
  templateUrl: './order-property-modal.component.html',
  styleUrl: './order-property-modal.component.scss',
})
export class OrderPropertyModalComponent implements OnInit {
  @Input() id: string;
  @Input() orderHeaderId: string;
  @Input() salesOrder: boolean;
  @Input() purchaseContract: boolean;

  @Output() baseService: any;

  fields: FormlyFieldConfig[];

  constructor(
    public purchaseOrderPropertyService: PurchaseOrderPropertyService,
    public salesOrderPropertyService: SalesOrderPropertyService,
    public purchaseContractPropertyService: PurchaseContractPropertyService,
    private purchaseOrderService: PurchaseOrderService,
    private salesOrderService: SalesOrderService,
    private formlyService: FormlyService,
  ) {}

  ngOnInit() {
    this.baseService = this.salesOrder
      ? this.salesOrderPropertyService
      : this.purchaseContract
        ? this.purchaseContractPropertyService
        : this.purchaseOrderPropertyService;
    this.getFields();
  }

  private getFields() {
    this.fields = [
      this.formlyService.text('heading', $localize`Heading`),
      this.formlyService.text(
        'displayText',
        $localize`Text`,
        undefined,
        undefined,
        (model: OrderProperty) => model.boolean,
      ),
      this.formlyService.checkbox('true', $localize`True`, undefined, undefined, (model: OrderProperty) => model.text),
    ];
  }

  saved() {
    if (this.salesOrder) {
      this.salesOrderService.refreshDetails.next();
    } else if (this.purchaseContract) {
      this.purchaseContractPropertyService.refreshDetails.next();
    } else {
      this.purchaseOrderService.refreshDetails.next();
    }
  }
}
